import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { rpcClient } from 'src/api/rpc/client';
import type {
  ListWorkflowTemplatesResponse,
  InstantiateWorkflowTemplateRequest,
  WorkflowDefinitionResponse,
} from '@erp/rpc';

/**
 * List all available workflow templates
 */
export function useListWorkflowTemplates() {
  return useQuery<ListWorkflowTemplatesResponse>({
    queryKey: ['workflow-templates', 'list'],
    queryFn: async () => {
      return await rpcClient.workflows.listTemplates({});
    },
  });
}

/**
 * Instantiate a workflow template
 */
export function useInstantiateWorkflowTemplate() {
  const queryClient = useQueryClient();

  return useMutation<
    WorkflowDefinitionResponse,
    Error,
    InstantiateWorkflowTemplateRequest
  >({
    mutationFn: async (request) => {
      return await rpcClient.workflows.instantiateTemplate(request);
    },
    onSuccess: () => {
      // Invalidate workflow definitions list to refresh after creating a new workflow
      queryClient.invalidateQueries({ queryKey: ['workflow-definitions'] });
    },
  });
}
